import { mergeProps } from '@zag-js/solid';
import { createMemo } from 'solid-js';
import { createSplitProps } from '../../utils/create-split-props';
import { ark } from '../factory';
import { useComboboxContext } from './use-combobox-context';
import { ComboboxItemProvider } from './use-combobox-item-context';
import { ComboboxItemPropsProvider } from './use-combobox-item-props-context';
export const ComboboxItem = (props) => {
    const [itemProps, localProps] = createSplitProps()(props, ['item', 'persistFocus']);
    const api = useComboboxContext();
    const mergedProps = mergeProps(() => api().getItemProps(itemProps), localProps);
    const itemState = createMemo(() => api().getItemState(itemProps));
    return (<ComboboxItemPropsProvider value={itemProps}>
      <ComboboxItemProvider value={itemState}>
        <ark.div {...mergedProps}/>
      </ComboboxItemProvider>
    </ComboboxItemPropsProvider>);
};
